import React, { useEffect, useState } from "react";
import parse, { domToReact } from "html-react-parser";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { sendRequest } from "../../util/httpClient";

const PrivacyPolicy = () => {
    const dispatch = useDispatch();
    const [state, setState] = useState({ isLoading: true, content: "" });
    const ModuleCustomSettingsIds = { PrivacyPolicy: 1350, CanadianPrivacyPolicy: 12374 };
    let authData = useSelector((state: ApplicationState) => {
        if (state.creditAuthData.authData != null) {
            return {
                isIDFUser: state.creditAuthData.authData.isIDFUser,
                partnerId: state.loggedInUser?.userInfo?.partnerID,
                status: state.creditAuthData.authData["status-code"],
            };
        }
        return { isIDFUser: "", partnerId: 36, status: "" };
    });
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const footerLogoHTML: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerProvider
            ? state.configurationState.configuration.partnerConfig.footerLogoHTML
            : ""
    );
    const isCignaPartner = useSelector((state: ApplicationState) =>
        state.configurationState &&
        state.configurationState.configuration.partnerConfig.partnerId &&
        state.configurationState.configuration.partnerConfig.partnerId === 2559
            ? true
            : false
    );

    let partnerData = useSelector((state: ApplicationState) => {
        if (state.configurationState?.configuration?.partnerConfig != null) {
            let { email, partnerId, phoneNumber } = state.configurationState.configuration.partnerConfig;
            return {
                email: email,
                phoneNumber: phoneNumber,
                partnerId: partnerId,
            };
        }
        return {
            email: "",
            phoneNumber: "",
            partnerId: 36,
        };
    });

    const options = {
        replace: ({ attribs, children }: any) => {
            if (!attribs) return;

            if (attribs.hasOwnProperty("class")) {
                if (attribs.class.indexOf("pdfPrint_icons") !== -1) {
                    return (
                        <a href="javascript:window.print()">
                            <i className="las la-print" style={{ fontSize: "32px", float: "right" }}></i>
                        </a>
                    );
                }
            }

            if (attribs.hasOwnProperty("href")) {
                if (attribs.href.indexOf("#thirdparty-collecting-info") !== -1) {
                    return (
                        <a
                            href="javascript:void(0);"
                            onClick={() => {
                                let element = document.querySelector(`a[name='thirdparty-collecting-info']`);
                                if (element) {
                                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                                }
                            }}
                        >
                            {domToReact(children, options)}
                        </a>
                    );
                }

                if (attribs.href.indexOf("#california") !== -1) {
                    return (
                        <a
                            href="javascript:void(0);"
                            onClick={() => {
                                let element = document.querySelector(`a[name='california']`);
                                if (element) {
                                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                                }
                            }}
                        >
                            {domToReact(children, options)}
                        </a>
                    );
                }

                if (attribs.href.indexOf("#") !== -1) {
                    return <a href="javascript:window.print();">{domToReact(children, options)}</a>;
                }
                if (attribs.href.indexOf("window.print()") !== -1) {
                    return <a href="javascript:window.print();">{domToReact(children, options)}</a>;
                }

                if (attribs.href.indexOf("javascript:void(0);") !== -1) {
                    const initialOnClickText = "(window.location.href=(window.location.href).split('#')[0]+'#";
                    if (attribs.hasOwnProperty("onclick") && attribs.onclick.startsWith(initialOnClickText)) {
                        let focusItemName: string = attribs.onclick;
                        focusItemName = focusItemName.replace(initialOnClickText, "");
                        focusItemName = focusItemName.replace(")", "");
                        focusItemName = focusItemName.replace("'", "");
                        return (
                            <a
                                href="javascript:void(0);"
                                onClick={() => {
                                    if (focusItemName) {
                                        let element = document.querySelector(`a[name='${focusItemName}']`);
                                        if (element) {
                                            element.scrollIntoView({ behavior: "smooth", block: "start" });
                                        }
                                    }
                                }}
                            >
                                {domToReact(children, options)}
                            </a>
                        );
                    }
                    return <a href="javascript:void(0);">{domToReact(children, options)}</a>;
                }

                if (attribs.href.indexOf("info@ezshield.com") !== -1 && partnerData.email) {
                    return (
                        <a href={`mailto:${partnerData.email}`} target="_blank" rel="noreferrer">
                            {partnerData.email}
                        </a>
                    );
                }

                if (attribs.href.indexOf("CommonDefinitions") !== -1 && authData.isIDFUser === false)
                    return (
                        <a href="/common-definition" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (
                    attribs.href.indexOf("TermsAndConditions") !== -1 ||
                    attribs.href.indexOf("terms-of-use") !== -1 ||
                    attribs.href.indexOf("canadian-terms-use") !== -1
                )
                    return (
                        <a href="/terms" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (
                    attribs.href.indexOf("EU-USPrivacyShield") !== -1 ||
                    attribs.href.indexOf("EUUSPrivacyShield") !== -1 ||
                    attribs.href.indexOf("privacy-shield-policy") !== -1
                )
                    return (
                        <a href="/privacy-shield" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf("EUGDPRNotice") !== -1 || attribs.href.indexOf("eu-gdpr-fair-processing-notice") !== -1)
                    return (
                        <a href="/gdpr" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf("ccpa-addendum") !== -1 || attribs.href.indexOf("CCPAAddendum") !== -1)
                    return (
                        <a href="/ccpa" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf("https://aim.yahoo.com/aim/us/en/optout/") !== -1) {
                    return (
                        <a href="https://www.verizon.com/about/privacy/" target="_blank" rel="noreferrer">
                            {domToReact(children, options)}
                        </a>
                    );
                }

                if (attribs.href.indexOf(window.location.hostname) === -1)
                    return (
                        <a href={attribs.href} target="_blank" rel="noreferrer">
                            {domToReact(children, options)}
                        </a>
                    );
            }
            if (attribs.name === "phone_number" && partnerData.phoneNumber) {
                return (
                    <a href={"tel:" + partnerData.phoneNumber}>
                        <span>{partnerData.phoneNumber}</span>
                    </a>
                );
            }
        },
    };

    const callAPI = (url: string, data: any): Promise<any> => {
        return sendRequest("POST", url, data, {
            ModuleCustomSettingsId: data.ModuleCustomSettingsId,
        }, true);
    };

    const isCanadianUser = (partnerId: any) => {
        const url = "api/CheckPartnerCountry/CheckPartnerCountry";
        const data: any = {}; //{PartnerID : partnerId};
        return callAPI(url, data).then((res: any): any => res.json());
    };

    const getPartnerCustomHtml = (data: any) => {
        const url = "api/GetPartnerCustomHtml/GetPartnerCustomHtml";
        callAPI(url, data)
            .then((res: any): any => res.json())
            .then((res: any): any => {
                if (res["hasError"] === false && res["legalDocuments"].length) {
                    setState({
                        isLoading: false,
                        content: res["legalDocuments"][0].value,
                    });
                }
            })
            .catch((error: Error): any => console.log(error));
    };

    useEffect(() => {
        let data: any = {
            ModuleCustomSettingsId: ModuleCustomSettingsIds.PrivacyPolicy,
        };
        if (authData.isIDFUser) {
            //check if canadian user
            isCanadianUser(authData.partnerId)
                .then((res: any): any => {
                    if (res.isCanadianPartner) {
                        data = {
                            ModuleCustomSettingsId: ModuleCustomSettingsIds.CanadianPrivacyPolicy,
                        };
                    }
                    getPartnerCustomHtml(data);
                })
                .catch((error: Error): any => console.log(error));
        } else {
            getPartnerCustomHtml(data);
        }
    }, [setState]);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className="faux-main-container">
                <div className=" row">
                    <div className="col-xs-12"></div>
                </div>

                <div className="row" id="content">
                    <div className="col-xs">
                        <div className="box box-has-shadow">
                            {state.isLoading ? (
                                <div className="box-content loading"></div>
                            ) : (
                                <div className="box-content">
                                    {!isCignaPartner && authData.isIDFUser && <h2>Privacy Policy</h2>}
                                    {!isCignaPartner && !!authData && authData.status !== "200" && <h2>Privacy Policy</h2>}
                                    {parse(state.content, options)}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="logo-container" dangerouslySetInnerHTML={{ __html: footerLogoHTML }}></div>
            </div>
        </React.Fragment>
    );
};

export default PrivacyPolicy;
